import {
  CONVERSATION_STATUSES_V3,
  type ConversationStatusV3,
} from "@redotech/redo-flows-common/rules-v3/types";
import { t } from "@redotech/redo-i18n";
import type { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
export const supportTicketStatusLabels = (): Record<
  ConversationStatusV3,
  string
> => ({
  OPEN: t("Open", { context: "support ticket status" }),
  CLOSED: t("Closed", { context: "support ticket status" }),
  SNOOZED: t("Snoozed", { context: "support ticket status" }),
  IN_PROGRESS: t("In Progress", { context: "support ticket status" }),
  HIDDEN: t("Hidden", { context: "support ticket status" }),
  ARCHIVED: t("Archived", { context: "support ticket status" }),
  DELETED: t("Deleted", { context: "support ticket status" }),
});

export const supportTicketStatusItems =
  (): RedoListItem<ConversationStatusV3>[] =>
    CONVERSATION_STATUSES_V3.map((status) => ({
      id: status,
      type: "text" as const,
      text: supportTicketStatusLabels()[status],
      value: status,
    }));
